/**
 * Small module that allows us to statically import the related module, while only
 * dynamically importing this small module with 'delayed-render.js'.
 */
export default () => import('./ImageModule')
